import { ReactNode, StrictMode, useEffect } from "react";
import { PublicClientApplication, InteractionType } from "@azure/msal-browser";
import { MsalAuthenticationTemplate, MsalProvider } from '@azure/msal-react';
import { msalConfig } from './msalConfig';
import { createRoot } from "react-dom/client";

const isFramed = window.self !== window.top;

export function initializeWithBeyonAuth(children: ReactNode) {

    // Ensure root element exists
    const rootElement = document.getElementById('root')
    if (!rootElement) {
        throw new Error('Root element not found')
    }


    if (isFramed) {
        createRoot(rootElement)
            .render(
                <StrictMode>
                    {children}
                </StrictMode>,
            );
    }

    else {

        const msalInstance = new PublicClientApplication(msalConfig);
        msalInstance.initialize()
            .then(() => {
                createRoot(rootElement)
                    .render(
                        <StrictMode>
                            <MsalProvider instance={msalInstance}>
                                <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
                                    {children}
                                </MsalAuthenticationTemplate>
                            </MsalProvider>
                        </StrictMode>,
                    );
            });
    }
}